<ng-template ngFor let-waypointRouteId [ngForOf]="routes.Waypoints">
    <app-historic-waypoint-route [waypointRouteId]="waypointRouteId" [polyline]="polyline"></app-historic-waypoint-route>
</ng-template>